import { PhoneNumberSchema } from '@repo/validation';

/** A geographic number: one-digit area code, then two groups of four. */
const LANDLINE_PATTERN = /^\+61([2378])(\d{4})(\d{4})$/;

/** Mobiles and every other non-geographic number, in groups of three. */
const THREE_DIGIT_GROUPS_PATTERN = /^\+61(\d{3})(\d{3})(\d{3})$/;

/**
 * Formats a phone number for display, a mobile as `+61 412 345 678` and a
 * landline as `+61 2 9876 5432`.
 * @param phoneNumber Phone number as stored or typed
 * @returns The formatted number, the value as given when `PhoneNumberSchema`
 * refuses it, or an empty string when there is none
 */
export const formatPhoneNumber = (phoneNumber?: string) => {
  const parsed = PhoneNumberSchema.safeParse(phoneNumber);
  if (!parsed.success) {
    return phoneNumber ?? '';
  }
  const pattern = LANDLINE_PATTERN.test(parsed.data)
    ? LANDLINE_PATTERN
    : THREE_DIGIT_GROUPS_PATTERN;
  return parsed.data.replace(pattern, '+61 $1 $2 $3');
};
